import Footer from './Shared-ui/Layout/Footer';
import ThemeCustomization from './Shared-ui/Theme';
import Routes from './Routes'
import { BrowserRouter } from 'react-router-dom';
import { AuthContextProvider } from './Shared-ui/Context/AuthenticationContext';
import { Box } from '@mui/material';
import Loader from './Loader';
import { Provider } from 'react-redux';
import Store from './Shared-ui/Store';
import MuiNotification from './Notification';
import VersionSignature from './Shared-ui/SharedComponents/VersionSignature';

function App() {
  return (
    <Box
      sx={{
        minHeight: "100vh"
      }}
    >
      <ThemeCustomization>
        <Footer>
          <Provider store={Store}>
            <Loader>
              <MuiNotification>
                <AuthContextProvider>
                  <Routes />
                </AuthContextProvider>
              </MuiNotification>
            </Loader>
          </Provider>
        </Footer>
        <VersionSignature />
      </ThemeCustomization>
    </Box>
  );
}

export default App;
